'use client';

import Image from 'next/image';
import Link from 'next/link';

import { HomeAnchorLink } from '@/components/home-anchor-link';

export default function Footer() {
  return (
    <footer className="bg-background">
      <div className="mx-auto flex max-w-6xl flex-col justify-between gap-8 px-5 py-12 md:flex-row md:px-10">
        {/* Logo / Branding */}
        <div className="flex flex-col justify-between">
          <div>
            <Link href="/" className="text-xl font-bold">
              <Image
                src="/statusly-logo.svg"
                width={124}
                height={43}
                alt="Statusly logo"
                className="transition-all group-data-[state=collapsed]:w-0"
              />
            </Link>
            <p className="text-muted-foreground text-sm">
              Easy uptime monitoring and status pages for indie developers.
            </p>
          </div>
          <div className="text-healthy mt-5 ml-1 flex items-center gap-2 text-sm">
            <div className="bg-healthy relative h-2.5 w-2.5 rounded-full">
              <div className="bg-healthy absolute h-full w-full animate-ping rounded-full" />
            </div>{' '}
            All systems go.
          </div>
        </div>

        {/* Links Section */}
        <div className="xs:grid-cols-2 grid grid-cols-1 gap-8">
          <div className="flex flex-col gap-2">
            <h4 className="text-foreground text-sm font-semibold">Product</h4>
            <HomeAnchorLink
              href="/#features"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Features
            </HomeAnchorLink>
            <HomeAnchorLink
              href="/#pricing"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Pricing
            </HomeAnchorLink>
            <HomeAnchorLink
              href="/#faq"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              FAQs
            </HomeAnchorLink>
            <Link
              href="/status-page"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Status Page
            </Link>
          </div>

          {/*<div className="flex flex-col gap-2">
            <h4 className="text-sm font-semibold text-foreground">Company</h4>
            <Link href="/about" className="text-sm text-muted-foreground hover:text-foreground">
              About
            </Link>
            <Link href="/careers" className="text-sm text-muted-foreground hover:text-foreground">
              Careers
            </Link>
          </div>*/}

          <div className="flex flex-col gap-2">
            <h4 className="text-foreground text-sm font-semibold">Company</h4>
            <Link
              href="/terms-of-service"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Terms of Service
            </Link>
            <Link
              href="/privacy-policy"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Privacy Policy
            </Link>
            <a
              href="mailto:hello@statusly.dev"
              className="text-muted-foreground hover:text-foreground text-sm"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
